import React from 'react';
import DeviceId from '../flows/DeviceId';

import { getCsrfToken } from '../helpers/GetCsrfToken';
import { logClientEvent } from '../helpers/ClientLog';
const paypal = require('@paypal/paypal-js');
const braintree = require('braintree-web');

export default class PayByPaypal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentFailed: false
    };
  }

  componentDidMount() {
    const { currency, language } = this.props.getCurrency();
    braintree.client
      .create({
        authorization: this.props.clientToken
      })
      .then(clientInstance => {
        // Create a PayPal Checkout component.
        return braintree.paypalCheckout.create({
          client: clientInstance
        });
      })
      .then(paypalCheckoutInstance => {
        // Set up PayPal with the checkout.js library
        return paypal.Button.render(
          {
            env: this.props.environment,
            style: {
              size: 'responsive',
              height: 40,
              width: 'inherit',
              color: 'gold',
              shape: 'rect',
              label: 'checkout',
              tagline: 'false'
            },

            payment: () => {
              logClientEvent('Pay button clicked', { PaymentMethod: 'PayPal' });
              return paypalCheckoutInstance.createPayment({
                flow: 'checkout', // Required
                amount: this.props.grandTotal, // Required
                currency: currency, // Required
                enableShippingAddress: false,
                shippingAddressEditable: false,
                landingPageType: 'billing',
                locale: language
              });
            },

            onAuthorize: (data, actions) => {
              this.props.submitPayment();
              logClientEvent('Payment submitted', { PaymentMethod: 'PayPal' });
              let email = "";
              return paypalCheckoutInstance
                .tokenizePayment(data)
                .then(payload => {
                  email = payload.details.email;
                  fetch('api/Braintree/Pay', {
                    method: 'post',
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      'X-XSRF-TOKEN': getCsrfToken(),
                      'DEVICE_ID': DeviceId.DEVICE_ID
                    },
                    body: this.props.generatePaymentBody(payload, email)
                  })
                    .then(response => response.json())
                    .then(data => {
                      if (data.success === true) {
                        this.props.storeCustomerEmail(email);
                        this.props.paymentSuccessful(data);
                      } else {
                        console.log(data.reason);
                        this.props.submitPaymentFail();
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.props.submitPaymentFail();
                    });
                });
            },

            onCancel: data => {
              console.log(
                'checkout.js payment cancelled',
                JSON.stringify(data, 0, 2)
              );
            },

            onError: err => {
              console.error('checkout.js error', err);
            }
          },
          '#paypal-button'
        );
        // return (null)
      })
      .then(() => {
        // The PayPal button will be rendered in an html element with the id
        // `paypal-button`. This will be called when the PayPal button
        // is set up and ready to be used.
      })
      .catch(err => {
        console.error(err);
        // Handle component creation error
      });
  }

  render() {
    // const formValid = this.state.formValid;
    return (
      <div
        style={
          this.props.submittingPayment === true
            ? { display: 'none' } : { display: 'block' }
        }
        className="payment-type"
      >
        <div id="paypal-button"></div>
      </div>
    );
  }
}
